import axios from "./../axios";
import {api} from "../axios.config";

const API_URL = api.apiUrl;
// Get event ID from URL
const BASE_URL = (eventId) => `/event/${eventId}`;

export const fetchSenderEmailDetails = (eventId) => {
    return axios.get(API_URL + BASE_URL(eventId) + `/sender-email`);
}

export const configureCustomSenderEmailName = (eventId, data) => {
    return axios.post(API_URL + BASE_URL(eventId) + `/sender-email`, {...data});
}

export const removeCustomSenderEmail = (eventId, email) => {
    return axios.delete(API_URL + BASE_URL(eventId) + `/sender-details/revert?email_id=${email}`);
}
export const sendReplyToAddressEmail = (eventId, payload) => {
    return axios.put(`${API_URL}/event/${eventId}`, payload);
}
export const fetchReplyToAddressEmail = (eventId) => {
    return axios.get(`${API_URL}/event/${eventId}`);
}